export default __webpack_public_path__ + "static/media/T560_T564_28A560C.69c17415.STEP";